document.addEventListener('DOMContentLoaded', () => {
	// Add click event to all buttons that open modals
	document.querySelectorAll('.modal-open').forEach(button => {
		button.addEventListener('click', () => {
			const modalSelector = button.dataset.modal; 
			const modal = document.querySelector(modalSelector); 
			if (modal) {
				modal.style.display = 'flex'; 
				document.body.style.overflow = 'hidden'; 
			}
		});
	});
	document.querySelectorAll('.modal-close').forEach(button => {
		button.addEventListener('click', () => {
			closeAllModals();
		});
	});

	// Close modal when Escape key is pressed
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeAllModals();
		}
	});
	window.addEventListener('click', (e) => {
		if (e.target.classList.contains('modal')) {
			closeAllModals();
		}
	});
});

function closeAllModals() {
	document.querySelectorAll('.modal').forEach(modal => {
		modal.style.display = 'none';
	});
	document.body.style.overflow = 'scroll';
	stopModalVideos();
}

// Reset video iframes by resetting their src
function stopModalVideos() {
	document.querySelectorAll('.modal-content iframe').forEach(iframe => {
		const src = iframe.getAttribute('src');
		iframe.setAttribute('src', src);
	});
}